import { AxiosResponse } from "axios";
import {
	IForecastRaw,
	IForecastValidation,
	IForecastVM,
} from "domain/Predictive";
import { ForecastVMErrors } from "domain/Predictive/Models/ForecastVMErrors";
import { useRequest } from "hooks/useRequest";
import { DateTime } from "luxon";
import { AvailableForecastModel } from "./AvailableForecastModel";

export const useDemandForecastRequester = () => {
	const request = useRequest("DemandForecast");

	return {
		SAVE: (
			rows: IForecastVM[]
		): Promise<{
			[key: string]: { min: {}; max: {}; mode: {} };
		} | null> => {
			return request
				.POST("Save", rows)
				.then((res: AxiosResponse<ForecastVMErrors[]>) =>
					res.data
						? res.data
								.map(
									(c) =>
										new ForecastVMErrors(
											c.inventoryID,
											c.errors
										)
								)
								.reduce(
									(b, c) => ({ ...b, ...c.buildErrorDate() }),
									{}
								)
						: null
				);
		},
		FORECAST: (
			start: DateTime,
			end: DateTime,
			body: { products: []; categories: []; stores: [] }
		) => {
			return request
				.POST(
					`forecast?start=${start.toFormat(
						"yyyy-MM-dd"
					)}&end=${end.toFormat("yyyy-MM-dd")}`,
					body
				)
				.then((res: AxiosResponse<IForecastVM[]>) => {
					return {
						data: res.data,
						range: {
							start,
							end,
							daysDiff: end.diff(start, ["days"]).days,
						},
					};
				});
		},
		FORECASTVALIDATE: (value: IForecastRaw[]) => {
			return request
				.POST("validate", value)
				.then((res: AxiosResponse<IForecastValidation>) => {
					if (res.data?.errors && res.data.errors.length > 0) {
						const errors = res.data.errors;
						const formatedErrors = errors.flatMap((c: any) =>
							c.validationFailures.flatMap((v: any) => ({
								line: c.line + 1,
								...v,
							}))
						);
						return { errors: formatedErrors };
					} else {
						const forecast = (res.data as any).forecast;
						const start = DateTime.fromISO((res.data as any).start);
						const end = DateTime.fromISO((res.data as any).end);

						return {
							forecast,
							range: {
								start,
								end,
								daysBetweenCount: end.diff(start, ["days"])
									.days,
							},
						};
					}
				});
		},
		TEMPLATE: () => {
			return request.GET(`template`);
		},
		CURRENTTEMPLATE: (start?: DateTime, end?: DateTime, body?: {}) => {
			return request.POST(
				`template/current?start=${start!.toFormat(
					"yyyy-MM-dd"
				)}&end=${end!.toFormat("yyyy-MM-dd")}`,
				body!
			);
		},
		GET_AVAILABLE_MODELS: () => {
			return request.GET("available-forecast-models").then((res: AxiosResponse<AvailableForecastModel[]>) => res.data);
		},
		UPDATE_MODEL_STATUS: (id: number, body: { isRequired: boolean, isDefaultBenchmark: boolean }) => {
			return request.PUT(`available-forecast-models/${id}/status`, body);
		},
		SET_FORECAST_MODEL: (availableForecastModelId: number) => {
			return request.POST("set-forecast-zip", { availableForecastModelId });
		},
		SET_BENCHMARK_MODEL: (availableForecastModelId: number) => {
			return request.POST("set-forecast-benchmark-zip", { availableForecastModelId });
		},
	};
};
